/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useMemo, useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { debounce } from "@mui/material/utils";
import { createStyles, makeStyles } from "@mui/styles";
import { getDropdownOptions } from "../../../../utils";
import Typography from "../Typography/Typography";

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles(() =>
  createStyles({
    root: {
      "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "rgba(0, 0, 0, 0.23) !important",
        borderWidth: "1px !important",
      },
    },
  })
);

export default function AsyncAutoComplete({
  api,
  name,
  value,
  onChange,
  optionKey,
  optionValue,
  label,
  placeholder,
  apiPayload = {},
  searchParam = "fullName",
  ...props
}) {
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const classes = useStyles();

  const fetch = useMemo(
    () =>
      debounce(async (request, callback) => {
        const { data } = await api({ ...request, ...apiPayload });
        callback(
          getDropdownOptions(data.content ?? [], optionKey, optionValue)
        );
      }, 400),
    []
  );

  useEffect(() => {
    let active = true;

    if (inputValue === "") {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({ [searchParam]: inputValue }, (results) => {
      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }

        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch]);

  return (
    <Autocomplete
      {...props}
      name={name}
      getOptionLabel={(option) =>
        typeof option === "string" ? option : option.key
      }
      filterOptions={(x) => x}
      className={classes.root}
      options={options}
      size="small"
      autoComplete
      includeInputInList
      filterSelectedOptions
      value={value}
      noOptionsText="No members"
      onChange={(event, newValue) => {
        setOptions(newValue ? [newValue, ...options] : options);
        onChange(newValue);
      }}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          fullWidth
        />
      )}
      renderOption={(renderProps, option) => {
        return (
          <li {...renderProps}>
            <Box style={{ padding: "0.5rem 0" }}>
              <Typography variant="small">{option.key}</Typography>
            </Box>
          </li>
        );
      }}
    />
  );
}
